'use strict';

/**
 * Recursively deletes non-truthy values from an object.
 *
 * @template T - The type of the input object.
 * @param {T} obj - The object from which to delete non-truthy values.
 * @param {number} [depth=0] - The current depth of recursion.
 * @returns {T | null} - A new object with non-truthy values removed, or null if the object is empty and depth is greater than 0.
 */ function deleteNonTruthyRecursive(obj, depth = 0) {
    if (!obj) return depth ? null : obj;
    const newObj = {};
    const entries = Object.entries(obj);
    if (!entries.length) return depth ? null : newObj;
    entries.forEach(([key, value])=>{
        if (!value) return;
        if (Array.isArray(value)) {
            const trimmedValue = value.filter(Boolean);
            if (trimmedValue.length) newObj[key] = 'trimmedValue';
        } else if (typeof value === 'object') {
            const trimmedValue = deleteNonTruthyRecursive(value, depth + 1);
            if (trimmedValue) newObj[key] = trimmedValue;
        } else {
            newObj[key] = value;
        }
    });
    return newObj;
}

module.exports = deleteNonTruthyRecursive;
